<template>
	<div style="padding: 20px;">
		<el-row :gutter="20">
			<el-col :span="24">
				<div class="centext-box">
					<div class="header">
						创建卡密
					</div>
					<div style="padding: 20px;" class="form">
						<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="160px"
							class="demo-ruleForm" label-position="left">
							<el-form-item label="所属软件" prop="software">
								<el-select v-model="ruleForm.software" clearable placeholder="请选择所属软件"
									style="width: 300px;margin-right: 10px;" size="small">
									<el-option v-for="(key,value) in software_info" :key="software_info[value].id"
										:label="formatValue(software_info[value],value)" :value="value">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="卡密类型" prop="type">
								<el-select v-model="ruleForm.type" clearable placeholder="卡密类型" style="width: 300px;"
									size="small">
									<el-option v-for="(key,value) in type_config" :key="type_config[value].id"
										:label="type_config[value].name" :value="type_config[value].id">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="生成类型">
								<div slot="label" style="display: flex;align-items: center;">
									<span>生成类型</span>
									<img src="../../assets/question.png" style="width: 20px;height: 20px;margin-left: 5px;cursor: pointer;" @click="openMsg(0)">
								</div>
								<el-radio-group v-model="ruleForm.create_type">
									<el-radio label="rand">随机</el-radio>
									<el-radio label="custom">指定内容</el-radio>
								</el-radio-group>
							</el-form-item>

							<el-form-item label="生成数量" prop="num" v-if="ruleForm.create_type==='rand'">
								<el-input-number size="small" v-model="ruleForm.num" controls-position="right" :min="0"
									:max="999"></el-input-number>
							</el-form-item>
							<el-form-item label="自定义卡密内容" prop="cards" v-if="ruleForm.create_type==='custom'">
								<div
									style="display: flex;flex-direction: column;font-size: 14px;line-height: 1.5;margin-top: 8px;">
									<div> 自定义卡密为收费功能，卡密长度必须大于6位，暂定每个卡密价格为0.1元，重复的卡密不能生成，单次最大生成50个自定义卡密。不填则为随机生成。</div>
									<div style="color: red;margin-bottom: 5px;">
										卡密内容（一行一个）
									</div>
									<el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="ruleForm.cards"
										style="width: 400px;">
									</el-input>
								</div>
							</el-form-item>
							<el-form-item label="允许多端数量" prop="max_num">
								<div slot="label" style="display: flex;align-items: center;">
									<span>允许多端运行数量</span>
									<img src="../../assets/question.png" style="width: 20px;height: 20px;margin-left: 5px;cursor: pointer;" @click="openMsg(1)">
								</div>
								<el-input-number size="small" v-model="ruleForm.max_num" controls-position="right"
									:min="0" :max="999"></el-input-number>
							</el-form-item>

							<el-form-item label="配置">
								<div slot="label" style="display: flex;align-items: center;">
									<span>配置</span>
									<img src="../../assets/question.png" style="width: 20px;height: 20px;margin-left: 5px;cursor: pointer;" @click="openMsg(2)">
								</div>
								<el-input type="text" placeholder="请输入配置" size="small" v-model="ruleForm.config"
									style="width: 300px;"></el-input>
							</el-form-item>
							<el-form-item label="备注">
								<el-input type="text" placeholder="请输入备注" size="small" v-model="ruleForm.one"
									style="width: 300px;"></el-input>
							</el-form-item>
							<el-form-item label="是否激活">
								<el-radio-group v-model="ruleForm.is_active">
									<el-radio :label="true">是</el-radio>
									<el-radio :label="false">否</el-radio>
								</el-radio-group>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" size="small" @click="submitForm('ruleForm')">立即创建</el-button>
							</el-form-item>
						</el-form>
					</div>
				</div>
			</el-col>
		</el-row>
		<el-dialog title="提示" :visible.sync="dialogCodeVisible" width="340px">
			<div style="padding: 0px 10px 0px 10px;font-size: 14px;text-align: center;">
				{{msg}}
			</div>
		</el-dialog>
		<el-dialog :title="copyCodeTitle" :visible.sync="dialogCopyCode" width="500px">
			<div style="padding: 10px;font-size: 18px;display: flex;align-items: flex-start;justify-content: center;max-height: 300px;overflow-y: auto;flex-direction: column;margin-bottom: 5px;" v-if="not_exist_cards.length>0">
				<div style="color: #000;font-size: 14px;margin-bottom:5px ;" v-for="(item,index) in not_exist_cards" :key="index">
					{{item}}
				</div>
			</div>
			<div style="color: #ccc;font-size: 12px;display: flex;align-items: center;justify-content: center;margin-top: 10px;width: 100%;" v-if="not_exist_cards.length>0">（点击确定复制按钮后自动复制上述卡密列表）</div>
			<div style="padding: 10;display: flex;align-items: center;justify-content: center;color: #ccc;font-size: 14px;" v-if="not_exist_cards.length==0">
				全部处理完毕
			</div>
			<span slot="footer" class="dialog-footer"
				style="display: flex;align-items: center;justify-content: center;">
				<el-button type="danger" size="small" @click="copyValue" v-if="not_exist_cards.length>0">确定复制</el-button>
				<el-button size="small" type="primary" @click="dialogCopyCode = false">关闭弹窗</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {mapState} from 'vuex'
	export default {
		computed: {
			...mapState({
				user: state => state.user
			})
		},
		data() {
			return {
				id: null,
				dialogCopyCode:false,
				copyCodeTitle:'',
				not_exist_cards:'',
				msg:'',
				msg_list:[
					'随机的意思是，卡密的内容是随机数字字母字符串，卡密的长度在【软件管理】里面修改。指定内容是指生成的卡密内容由您自己定义，指定内容要收费，一个卡密收费0.1元。',
					'意思是该账号允许几个端同时登陆',
					'账号配置可以用来做很多自定义功能，没有用到请忽略。',],
				dialogCodeVisible:false,
				ruleForm: {
					type: '',
					num: '',
					one: '',
					max_num: '1',
					software: '',
					config: '',
					create_type: 'rand',
					cards: '',
					is_active: false,
				},
				rules: {
					software: [{
						required: true,
						message: '请选择所属软件',
						trigger: 'change'
					}],
					type: [{
						required: true,
						message: '请选择卡密类型',
						trigger: 'change'
					}],
					num: [{
						required: true,
						message: '请输入生成数量',
						trigger: 'blur'
					}],
					max_num: [{
						required: true,
						message: '请输入允许多端数量',
						trigger: 'blur'
					}],
					cards: [{
						required: true,
						message: '请输入自定义卡密内容',
						trigger: 'blur'
					}],
					config: [{
						required: true,
						message: '请输入配置',
						trigger: 'blur'
					}],
				},
				type_config: {},
				software_info: {},
				card_state_conf: {},
				is_copy:false
			}
		},
		created() {
			this.resetForm()
			this.getData()
		},
		beforeDestroy() {
			window.localStorage.setItem('ruleForm_'+this.user.center_id,JSON.stringify(this.ruleForm))
		},
		methods: {
			formatValue(item,key){
				console.log(item)
				return item.one||key
			},
			
			openMsg(index){
				this.msg = this.msg_list[index]
				setTimeout(()=>{
					this.dialogCodeVisible = true
				},100)
			},
			getData() {
				this.$H.post('/verify_center/v1_0_1.Card/List', {
					card: "",
					card_state: "all",
					card_type: "",
					software: "",
					page: 1
				}).then(res => {
					if (res.data) {
						this.type_config = res.data.type_config
						this.software_info = res.data.software_info
						this.card_state_conf = res.data.card_state_conf
					}
				})
			},
			submitForm() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						if (!this.id) {
							this.$H.post('/verify_center/v1_0_1.Card/Create',this.ruleForm).then(res=>{
								if(!res.data) return;
								this.not_exist_cards = res.data.card_list
								this.copyCodeTitle =  '创建【'+res.data.card_list.length+'】个【'+this.type_config[this.ruleForm.type].name+'】卡成功'
								this.dialogCopyCode = true
							
							})
						}
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			copyValue(){
				let content = this.not_exist_cards.join('\n')
				this.$copyText(content).then((e)=> {
				   this.$message.success('复制成功')
				},  (e)=> {
				    console.log(e)
				})
			},
			resetForm() {
				let ruleForm = window.localStorage.getItem('ruleForm_'+this.user.center_id)
				if(ruleForm){
					this.ruleForm = JSON.parse(ruleForm)
				}else{
					this.$nextTick(() => {
						this.$refs['ruleForm'].resetFields();
					})
				}
				
			}
		}
	}
</script>

<style scoped>
	.centext-box {
		border-radius: 5px;
		background-color: rgb(66, 75, 79);
		color: #fff
	}

	.centext-box .header {
		font-size: 14px;
		
	}

	.form>>>.el-form-item__label {
		color: #fff !important;
	}

	.form>>>.el-input__inner {
		background-color: rgb(66, 75, 79);
		border: 1px solid #ccc !important;
		color: #fff;
	}

	.form>>>.el-radio__label {
		color: #fff;
	}

	.form>>>.el-textarea__inner {
		background-color: rgb(66, 75, 79);
		border: 1px solid #ccc !important;
		color: #fff;
	}
</style>